const defaultSeparator = `'`;

export default
{
    /**
     * Format a number with thousand separators.
     *
     * @param {Number} n
     * @param {String} separator
     * @returns {String}
     */
    thousands(n, separator = defaultSeparator)
    {
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    },

    /**
     * Generate a random fixed-length hexadecimal integer (left-padded with zeros).
     *
     * @param {Number} length Number of hex digits to generate. Defaults to 7.
     * @returns {String}
     */
    randomHex(length = 7)
    {
        const max = Math.pow(16, length);

        return parseInt(Math.random() * max).toString(16).padStart(length, '0');
    },
};
